
















import Vue from "vue"

import ResultList from "../ResultList.vue"

export default Vue.extend({
  props: {
    content: {
      type: Object as Prop<api.content.Content>,
      required: true
    },
    unit: {
      type: Object as Prop<api.unit.GetUnitResponseData>,
      required: true
    },
    questions: {
      type: Array as Prop<api.unitImpl.Question[]>,
      required: true
    }
  },

  components: {
    ResultList
  },

  methods: {
    clickCheckIcon(question: api.unitImpl.Question) {
      this.$emit("click-check-icon", question)
    }
  }
})
